import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../cn.js";
export function Field({ label, hint, error, id, children, required }) {
    return (_jsxs("div", { className: "grid gap-1.5", children: [_jsxs("label", { htmlFor: id, className: "text-sm font-medium text-ink", children: [label, required && _jsx("span", { className: "text-danger", children: " *" })] }), children, error ? _jsx("p", { role: "alert", className: "text-xs text-danger", children: error }) : hint ? _jsx("p", { className: "text-xs text-ink-3", children: hint }) : null] }));
}
const base = "w-full rounded-md border border-line bg-surface px-3 text-sm text-ink placeholder:text-ink-3 focus:border-navy disabled:bg-tint";
export function Input({ className, ...rest }) {
    return _jsx("input", { className: cn(base, "h-11", className), ...rest });
}
export function Textarea({ className, ...rest }) {
    return _jsx("textarea", { className: cn(base, "min-h-24 py-2", className), ...rest });
}
export function NativeSelect({ className, children, ...rest }) {
    return _jsx("select", { className: cn(base, "h-11", className), ...rest, children: children });
}
//# sourceMappingURL=Field.js.map